import React from 'react'

import ManageCV from '../../components/managecv/ManageCV'




const ManageCVs = () => {
    return (
        <>
            <ManageCV />
        </>
    )
}

export default ManageCVs
